var map = {
	"./BuddhaAkshay/index.css": [
		60533,
		533
	],
	"./JanBhavishya/index.css": [
		11154,
		154
	],
	"./Suvarna/index.css": [
		92056,
		56
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65264;
module.exports = webpackAsyncContext;